import { MEMBERSHIP_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { IMembershipVisitDetailsResponse } from "@/api_framework/api_modals/Membership";
import { setMembershipVisitDetails } from "@/app_redux/reducers/slices/auth/membership.slice";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useMembershipVisitDetailsAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (user_membership_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${MEMBERSHIP_MODULE?.MEMBERSHIP_VISIT_DETAILS?.baseURL}${user_membership_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IMembershipVisitDetailsResponse>) => {
            if (res.data.status) {
              dispatch(setMembershipVisitDetails({ data: res.data.data }));
            } else {
              dispatch(setMembershipVisitDetails({ data: null }));
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setMembershipVisitDetails({ data: null }));
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        captureError(e);
        dispatch(setMembershipVisitDetails({ data: null }));
      }
    },
    [dispatch],
  );
  return { execute };
};
